import HomeController from './homeController';
import UserService from '../user/services/userService';

const Home = {
    template: require('./homeView.html'),
    controller: HomeController
};

export default angular.module('app.home', [])
    .component('home', Home)
    .service('UserService', UserService)
    .name;


// WEBPACK FOOTER //
// ./src/app/pages/home/homeComponent.js